import ReactDOM from 'react-dom/client';
import './index.scss';
import 'semantic-ui-css/semantic.min.css'
import { BrowserRouter, Route, Routes } from "react-router";
import ProjectPage from './components/ProjectPage/ProjectPage';
import Header from './components/Header/Header';
import AllProjects from './components/AllProjects/AllProjects';
import AllAuthors from './components/AllAuthors/AllAuthors';
import MyProjects from './components/MyProjects/MyProjects';
import HowItWorks from './components/HowItWorks/HowItWorks';
import HeroesPage from './components/HeroesPage/HeroesPage';
import PlacesPage from './components/PlacesPage/PlacesPage';
import ObjectsPage from './components/ObjectsPage/ObjectsPage';

ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
).render(  
  <BrowserRouter>
    <Header/>
    <Routes>
      <Route path="/" element={<AllProjects />} />
      <Route path="/my-projects" element={<MyProjects />} />
      <Route path="/authors" element={<AllAuthors />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/project/:projectId" element={<ProjectPage />} />
      <Route path="/project/:projectId/heroes" element={<HeroesPage />} />
      <Route path="/project/:projectId/places" element={<PlacesPage />} />
      <Route path="/project/:projectId/objects" element={<ObjectsPage />} />
      <Route path="/project/:projectId/part/:partId" element={<ProjectPage />} />
    </Routes>
  </BrowserRouter>
);